import { Plus } from '@phosphor-icons/react';

import { Button } from '../ui/Button';
import pt from '../../locales/pt';
import { cn } from '../../utils/cn';
import { GoalTermHint } from './GoalTermHint';

function activeSummaryLabel(count) {
  if (count === 1) return pt.goals.vision.activeSummaryOne;
  return pt.goals.vision.activeSummaryMany.replace('{count}', String(count));
}

/** page-head do .pen (Objetivos · Visão / Vazio) — cabeçalho partilhado por todos os viewports. */
export function GoalsVisionHeader({ populated, count = 0, onCreate, className }) {
  return (
    <header className={cn('flex items-center justify-between gap-space-4', className)}>
      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="type-section text-sage-on-tint">{pt.goals.vision.eyebrow}</p>
        <h1 className="type-title-page text-foreground">
          {populated ? pt.goals.vision.titlePopulated : pt.goals.vision.titleEmpty}
        </h1>
        <div className="flex items-center gap-space-2">
          <p className="type-body-sm text-muted-foreground">
            {populated ? activeSummaryLabel(count) : pt.goals.vision.emptySummary}
          </p>
          <GoalTermHint term="smart" variant="icon" />
        </div>
      </div>

      {populated ? (
        <div className="hidden shrink-0 items-center gap-space-3 md:flex">
          <Button type="button" size="sm" onClick={onCreate}>
            <Plus className="mr-1 h-4 w-4" aria-hidden />
            {pt.goals.new}
          </Button>
        </div>
      ) : null}
    </header>
  );
}
